import React, { Component } from 'react'
import './qrCode.scss'
import { connect }  from 'react-redux'
import preload from 'components/enhancer/preload'
import { actions } from './redux'
import composeHOC from 'shared/utils/composeHOC'
class qrCode extends Component {
  static title = '';

  constructor(props) {
    super(props)
  }
  componentDidMount(){
    let { router, user } = this.props

    // this.setState({
    //   currentUrl: router.location.query.currentUrl
    // })
  }

  render() {

    return (
      <div className="qrCode-bg">
        <div className="qrCode">
          <img src={`https://www.madailicai.com/mars-api/open-api/qr.jpeg?content=${this.props.currentUrl}&size=400&margin=5`} />
          <div className="qrCode-text">
            用手机扫描上图的二维码，即可在手机上继续阅读该网页。
          </div>
        </div>  
      </div>
    )
  }
}

export default composeHOC(
  connect(state => ({
    currentUrl: state.qrCode.currentUrl
  }), {
  }),
  preload(({dispatch, currentUrl}) => {
    return Promise.all([
      dispatch(actions.getCurrentUrl(currentUrl))
    ])
  })
)(qrCode)




// WEBPACK FOOTER //
// ./modules/qrCode/qrCode.js